import useTranslations from '../../../hooks/useTranslations'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { length } from '../../../utils/javascript'

const BodyModifications = () => {
  const { t } = useTranslations()

  const dataSource = [
    {
      key: '1',
      date: '2021-02-10',
      errorCode: 'N/A',
      issueDescription: 'inv_AutomobileIssueDescription1',
      resolution: 'inv_AutomobileIssueResolution2',
      serviceCenterName: 'ABC Body Shop',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '2',
      date: '2021-06-15',
      errorCode: 'N/A',
      issueDescription: 'inv_AutomobileIssueDescription3',
      resolution: 'inv_AutomobileIssueResolution4',
      serviceCenterName: 'XYZ Auto Collision',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '3',
      date: '2022-01-20',
      errorCode: 'N/A',
      issueDescription: 'inv_PartIssueDescription1',
      resolution: 'inv_PartResolution1',
      serviceCenterName: 'DEF Bodyworks',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '4',
      date: '2022-04-10',
      errorCode: 'N/A',
      issueDescription: 'inv_PartIssueDescription2',
      resolution: 'inv_PartResolution2',
      serviceCenterName: 'GHI Auto Body',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '2p165e4d-30jk-6789',
      dppOfPartInserted: '1p165e4d-30jk-4321',
    },
    {
      key: '5',
      date: '2022-08-25',
      errorCode: 'N/A',
      issueDescription: 'inv_PartIssueDescription3',
      resolution: 'inv_PartResolution3',
      serviceCenterName: 'JKL Glass Repair',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '3p165e4d-30jk-8910',
      dppOfPartInserted: '4p165e4d-30jk-3456',
    },
  ]

  const columns = [
    {
      title: t('job_Date'),
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t('job_ErrorCode'),
      dataIndex: 'errorCode',
      key: 'errorCode',
    },
    {
      title: t('inv_IssueDescription'),
      dataIndex: 'issueDescription',
      key: 'issueDescription',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_Resolution'),
      dataIndex: 'resolution',
      key: 'resolution',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_ServiceCenterName'),
      dataIndex: 'serviceCenterName',
      key: 'serviceCenterName',
    },
    {
      title: t('inv_DPPUpdated'),
      dataIndex: 'engineDppUpdated',
      key: 'engineDppUpdated',
    },
    {
      title: t('inv_DPPOfPartExtracted'),
      dataIndex: 'dppOfPartExtracted',
      key: 'dppOfPartExtracted',
    },
    {
      title: t('inv_DPPOfPartInserted'),
      dataIndex: 'dppOfPartInserted',
      key: 'dppOfPartInserted',
    },
  ]
  return (
    <ANTDTable
      dataSource={dataSource}
      columns={columns}
      // pagination={false}
      pagination={{
        pageSize: 5,
        total: length(dataSource) || 0,
      }}
      scroll={{ x: 600 }}
      // loading={loader}
    />
  )
}

export default BodyModifications
